export class AssignLeadsInput {
  leadIds: string[];
  userId: string;
  comments?: string;
}
